module.exports = __webpack_public_path__ + "static/media/p2008tavan.0a4c4b4e.jpg";